import React, { useContext, useEffect, useMemo, useState } from "react";
import ContrySelect from '../../../components/contryselect/ContrySelect'
import countryList from "react-select-country-list";
import toast from "react-hot-toast";
import { Grid, TextField, Typography, Button, Checkbox, FormControlLabel } from "@mui/material";
import { DemoLoginApi } from '../../../api/request/auth';
import { ThemeContext } from "../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import { parsePhoneNumberFromString, getExampleNumber } from "libphonenumber-js";
import UserDetail from "./UserDetail";


const OpenDemoAccount = () => {
  const { darkMode } = useContext(ThemeContext)
  const [formValues, setFormValues] = useState({ address: "", country: "", deposit: "100000", email: "", name: "", phone: "", nodeID: 2, agree: false, });
  const [isCompanyDetailsVisible, setIsCompanyDetailsVisible] = useState(false);
  const countries = useMemo(() => countryList().getData(), []);
  const [formErrors, setFormErrors] = useState({});
  const { t } = useTranslation()
  const [isSubmitted, setIsSubmitted] = useState(false);
      const [isSubmitting, setIsSubmitting] = useState(false);
  
  useEffect(() => {
    const storedData = sessionStorage.getItem("demoAccountData");
    if (storedData) {
      setIsSubmitted(true);
    }
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    const fieldError = validateField(name, value);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      ...fieldError,
      [name]: fieldError[name] || "",
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormValues({ ...formValues, [name]: checked });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents the default form submission behavior
    if (isSubmitting) return;
    const errors = validate();
    setFormErrors(errors);

    if (Object.keys(errors).length !== 0) return;
    setIsSubmitting(true);
    try {
        let params = {
            login_type: "api",
            ...formValues,
            country: formValues.country,
        };
        const { data } = await DemoLoginApi(params);

        if (data) {
            setIsSubmitted(true)
            setIsSubmitting(true);
            sessionStorage.setItem("demoAccountData", JSON.stringify(data));
            toast.success("Account Created successfully! Please Login");
        } else {
            toast.error("Account Creation failed");
        }
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error?.response?.data?.message);
        } else {
            toast.error("An error occurred while logging in.");
        }
    }
    finally {
        setIsSubmitting(false);
    }
};

  // const handleCountryChange = (selectedOption) => {
  //   setFormValues({ ...formValues, country: selectedOption?.label || "" });
  //   setFormErrors({ ...formErrors, country: "" });
  // };

  const handleCountryChange = (selectedOption) => {
    const newCountry = selectedOption?.label || "";
    const newCountryCode = selectedOption?.value || "";

    setFormValues((prev) => ({ ...prev, country: newCountry }));

    const error = validateField("country", newCountry);
    setFormErrors((prev) => ({
      ...prev,
      country: error.country || "",
    }));

    // If phone is filled, validate it according to the selected country
    if (formValues.phone.trim()) {
      let phoneError = "";

      try {
        const phone = parsePhoneNumberFromString(formValues.phone, newCountryCode);
        if (!phone || !phone.isValid()) {
          phoneError = "Invalid phone number for selected country";
        } else {
          // Dynamically get expected phone length for that country
          const example = getExampleNumber(newCountryCode);
          const expectedLength = example?.nationalNumber?.length;

          const actualLength = phone.nationalNumber.length;
          if (expectedLength && (actualLength < expectedLength || actualLength > expectedLength)) {
            phoneError = `Phone number should be exactly ${expectedLength} digits for ${newCountry}`;
          }
        }
      } catch (err) {
        phoneError = "Invalid phone number format";
      }

      setFormErrors((prev) => ({
        ...prev,
        phone: phoneError,
      }));
    }
  };

  const handleCompanyClick = () => {
    setIsCompanyDetailsVisible(!isCompanyDetailsVisible);
  };

  const validate = () => {
    const errors = {};
    if (!formValues.name.trim()) {
      errors.name = "Name is required";
    } else if (formValues.name.trim().length < 4) {
      errors.name = "Name must be at least 4 characters";
    } if (!formValues.email.trim()) errors.email = "Email is required";
    if (!formValues.phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (formValues.country) {
      const selectedCountry = countries.find(
        (option) => option.label === formValues.country
      );
      const countryCode = selectedCountry?.value;

      try {
        const parsedPhone = parsePhoneNumberFromString(formValues.phone, countryCode);
        if (!parsedPhone || !parsedPhone.isValid()) {
          errors.phone = "Invalid phone number for selected country";
        } else {
          const nationalNumberLength = parsedPhone.nationalNumber.length;
          if (nationalNumberLength < 7 || nationalNumberLength > 15) {
            errors.phone =
              "Phone number must be between 7 and 15 digits";
          }
        }
      } catch (err) {
        errors.phone = "Invalid phone number format";
      }
    }
    if (!formValues.address.trim()) errors.address = "Address is required";
    if (!formValues.country.trim()) errors.country = "Country is required";
    if (!formValues.deposit.trim()) errors.deposit = "Deposit is required";
    return errors;
  };

  const validateField = (name, value) => {
    const error = {};

    switch (name) {
      case "name":
        if (!value.trim()) error.name = "Name is required";
        else if (value.trim().length < 4) error.name = "Name must be at least 4 characters";
        break;

      case "email":
        if (!value.trim()) {
          error.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error.email = "Invalid email format";
        }
        break;

      case "phone":
        if (!value.trim()) error.phone = "Phone number is required";
        else if (formValues.country) {
          const selectedCountry = countries.find(opt => opt.label === formValues.country);
          const countryCode = selectedCountry?.value;
          try {
            const parsedPhone = parsePhoneNumberFromString(value, countryCode);
            if (!parsedPhone || !parsedPhone.isValid()) {
              error.phone = "Invalid phone number for selected country";
            } else {
              const len = parsedPhone.nationalNumber.length;
              if (len < 7 || len > 15) {
                error.phone = "Phone number must be between 7 and 15 digits";
              }
            }
          } catch {
            error.phone = "Invalid phone number format";
          }
        }
        break;

      case "address":
        if (!value.trim()) error.address = "Address is required";
        break;

      case "country":
        if (!value.trim()) error.country = "Country is required";
        break;

      case "deposit":
        if (!value.trim()) error.deposit = "Deposit is required";
        break;

      default:
        break;
    }

    return error;
  };

  const isFormValid = () => {
    const errors = validate();
    return Object.keys(errors).length === 0;
  };

  return (
    isSubmitted ? (
      <UserDetail />
    ) : (
      <form onSubmit={handleSubmit}>
        {/* {isCompanyDetailsVisible ? (
        <CompanyDetail onBackToLogin={handleCompanyClick} />
      ) : ( */}
        <Grid container spacing={2} sx={{ padding: "15px" }}>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={12}>
              <Typography variant="body1" gutterBottom sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('openDemoAccount')}</Typography>
            </Grid>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('company')} </Typography></Grid>
            <Grid item xs={8}><Typography variant="body2" className="text-primary" onClick={handleCompanyClick}>{process.env.REACT_APP_COMPANY_NAME}</Typography></Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('Name')}</Typography></Grid>
            <Grid item xs={8}>
              <TextField error={!!formErrors.name} helperText={formErrors.name} placeholder={t('Name')} name="name" variant="outlined" fullWidth size="small" value={formValues.name} onChange={handleInputChange} className="custom-textfield" />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}> <Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('email')} </Typography></Grid>
            <Grid item xs={8}><TextField error={!!formErrors.email} helperText={formErrors.email} name="email" variant="outlined" fullWidth placeholder={t('email')} size="small" value={formValues.email} onChange={handleInputChange} className="custom-textfield" /></Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('address')} </Typography> </Grid>
            <Grid item xs={8}>
              <TextField error={!!formErrors.address} helperText={formErrors.address} placeholder={t('address')} name="address" variant="outlined" fullWidth size="small" value={formValues.address} onChange={handleInputChange} className="custom-textfield" />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t("country")}</Typography></Grid>
            <Grid item xs={8}>
              <ContrySelect placeholder={t('selectcountry')} options={countries} value={countries.find(option => option.label === formValues.country)} onChange={handleCountryChange} />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t("PhoneNumber")}</Typography> </Grid>
            <Grid item xs={8}>
              <TextField error={!!formErrors.phone} helperText={formErrors.phone} placeholder={t('PhoneNumber')} name="phone" variant="outlined" fullWidth size="small" value={formValues.phone} onChange={handleInputChange} className="custom-textfield" />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('deposit')}</Typography></Grid>
            <Grid item xs={8}><TextField error={!!formErrors.deposit} helperText={formErrors.deposit} sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }} name="deposit" variant="outlined" size="small" fullWidth value={formValues.deposit} onChange={handleInputChange} className="custom-textfield" /></Grid>
          </Grid>


          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={12}>
              <FormControlLabel control={
                <Checkbox name="agree" checked={formValues.agree} onChange={handleCheckboxChange} className="custom-checkbox" />}
                label={t('agreeText')}
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", }, color: darkMode ? "var(--lightText)" : 'var(--black)' }} />
              <Typography className="text-primary" variant="body2" ml={3} mt={1} component="a" href="https://hybridsolutions.com" target="_blank" rel="noopener noreferrer">https://hybridsolutions.com</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Grid item>
              <Button disabled={!isFormValid() || isSubmitting} type="submit" variant="contained" color="secondary" size="" sx={{ border: '1px solid green', marginTop: "20px", color: "white", padding: '5px', pl: 2, pr: 2, textTransform: "none", }}>{isSubmitting ? t('submitting') : t('openDemoAccount')}
              </Button>
            </Grid>
          </Grid>

        </Grid>
        {/* )} */}
      </form>
    )
  );
};

export default OpenDemoAccount;